// services/appeals.js
import api from './api';

export const AppealsAPI = {
  getBloodAppeals: (page = 1) => api.get('/blood_appeals', { params: { page } }),
  approveAppeal: (id) => api.post(`/blood_appeals/${id}/approve`),
  rejectAppeal: (id) => api.post(`/blood_appeals/${id}/reject`),
};